import React from 'react';
import './TimeSlotPicker.css';

function generateTimeSlots() {
  const slots = [];
  for (let h = 0; h <= 23; h++) {
    slots.push(`${String(h).padStart(2, '0')}:00`);
    slots.push(`${String(h).padStart(2, '0')}:30`);
  }
  return slots;
}

function isTimeDisabled(timeStr, selectedDate) {
  if (!selectedDate) return false;

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const selected = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    selectedDate.getDate()
  );

  if (selected.getTime() > today.getTime()) {
    return false;
  }

  // Same day: disable times within 1 hour from now
  const [hours, minutes] = timeStr.split(':').map(Number);
  const slotTime = new Date(now);
  slotTime.setHours(hours, minutes, 0, 0);

  const minTime = new Date(now.getTime() + 60 * 60 * 1000); // now + 1 hour
  return slotTime <= minTime;
}

function TimeSlotPicker({ selectedDate, selectedTime, onTimeSelect }) {
  const slots = generateTimeSlots();

  return (
    <div className="timeslot-picker">
      <div className="timeslot-grid">
        {slots.map((time) => {
          const disabled = isTimeDisabled(time, selectedDate);
          const isSelected = selectedTime === time;

          return (
            <button
              key={time}
              className={`timeslot ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={() => !disabled && onTimeSelect(time)}
              disabled={disabled}
            >
              {time}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TimeSlotPicker;
